import { render, staticRenderFns } from "./application.vue?vue&type=template&id=4027d7b8&scoped=true"
import script from "./application.vue?vue&type=script&route=%2Fasset%2Fapplication&lang=js"
export * from "./application.vue?vue&type=script&route=%2Fasset%2Fapplication&lang=js"
import style0 from "./application.vue?vue&type=style&index=0&id=4027d7b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027d7b8",
  null
  
)

export default component.exports